import react from "react";
import { Link } from "react-router-dom";

const Login = () => {
  return (
    <>
      <div className="inner-banner before-none bg-white border-top">
        <div className="container">
          <div className="inner-banner-txt">
            <nav aria-label="breadcrumb" className="breadcrumb-nav">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Login{" "}
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      <div className="main-section login-pg border-bottom">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-sm-6 col-xs-12 align-self-center">
              <div className="user-login-box">
                <h1 className="fs-16 wow fadeInUp">Sign In</h1>
                <form method="post" action="#" autoComplete="off">
                  <div className="field">
                    <label>Email</label>
                    <input type="text" name="email" className="form-control" />
                  </div>
                  <div className="field">
                    <label>Password</label>
                    <input
                      type="Password"
                      name="Password"
                      className="form-control"
                    />
                  </div>
                  <div className="field">
                    <p>
                      <Link to="/forgot-password" className="link">
                        Forgot your password?
                      </Link>
                    </p>
                    <button>
                      {" "}
                      <span className="mbri-login pr-2" /> Sign in{" "}
                    </button>
                  </div>
                </form>
              </div>
            </div>
            <div className="col-lg-6 col-sm-6 col-xs-12">
              <div className="user-message-box border">
                <div className="bg-light">
                  <h2 className="fs-16 wow fadeInUp">New Customer?</h2>
                  <p className="wow fadeInUp">
                    Create an account with us and you'll be able to:
                  </p>
                  <ul className="prd-point">
                    <li>Check out faster</li>
                    <li>Save multiple shipping addresses</li>
                    <li>Access your order history </li>
                    <li>Track new orders </li>
                    <li>Save items to your Wish List</li>
                  </ul>
                  <Link to="/register" className="btn">
                    <span className="mbri-edit pr-2" />
                    Create Account
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
